module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("h5T4N"))).then(() => parcelRequire('5erN3'));